import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const MainHeading = styled(Typography, {
  name: 'MainHeading',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  fontFamily: 'Source Sans Pro Semibold',
  fontSize: '24px',
  marginBottom: theme.spacing(2),
}))
